import React, { createContext, useContext, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { theme, lightTheme } from '../styles/theme';

type Mode = 'dark' | 'light';
const ThemeContext = createContext({ mode: 'dark' as Mode, toggle: () => {} });
export const useSiteTheme = () => useContext(ThemeContext);

export function SiteTheme({ children }: { children: React.ReactNode }) {
  const [mode, setMode] = useState<Mode>(() => document.documentElement.dataset.theme === 'light' ? 'light' : 'dark');
  const [explicit, setExplicit] = useState(() => {
    try { return !!localStorage.getItem('portfolio-theme'); } catch { return false; }
  });
  useEffect(() => {
    document.documentElement.dataset.theme = mode;
    document.documentElement.style.colorScheme = mode;
  }, [mode]);
  useEffect(() => {
    const query = window.matchMedia('(prefers-color-scheme: light)');
    const update = () => { if (!explicit) setMode(query.matches ? 'light' : 'dark'); };
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, [explicit]);
  const toggle = () => {
    const next = mode === 'dark' ? 'light' : 'dark';
    setExplicit(true);
    setMode(next);
    try { localStorage.setItem('portfolio-theme', next); } catch { /* Themes still work when storage is unavailable. */ }
  };
  return <ThemeContext.Provider value={{ mode, toggle }}><ThemeProvider theme={mode === 'dark' ? theme : lightTheme}>{children}</ThemeProvider></ThemeContext.Provider>;
}
